<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>

    <!-- 신청자 목록 조회 -->
    <apply-donor-list-comp ref="ApplyDonorList" @returnResult="onClickRow"></apply-donor-list-comp>

    <!--신청 내역 팝업 -->
    <apply-donor-modal-comp
      :is-show.sync="isShowUserModal"
      ref="ApplyDonorModal"
      @returnResult="onPrint"
      @updateList="refreshList"
    ></apply-donor-modal-comp>

    <!-- 신청서 pdf 출력 -->
    <printable-applicant
      v-if="isPrintableApplicant"
      :is-show.sync="isPrintableApplicant"
      :print-data="printData"
      ref="printApplicant"
    />
  </div>
</template>

<script>
import ApplyDonorListComp from "@/pages/Scholarship/Components/ApplyDonorListComp";
import ApplyDonorModalComp from "@/pages/Scholarship/Components/ApplyDonorModalComp";
import PrintableApplicant from "@/pages/Scholarship/Components/PrintableApplicant";

export default {
  components: {
    ApplyDonorListComp,
    ApplyDonorModalComp,
    PrintableApplicant
  },

  data() {
    return {
      isShowUserModal: false,
      isPrintableApplicant: false,
      printData: null,
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 100
      },
      orgData: null
    };
  },
  methods: {
    onClickRow(item, e) {
      console.log(item);
      if (item) {
        this.orgData = item;
        this.$refs.ApplyDonorModal.setData(item);
        this.isShowUserModal = true;
        this.isPrintableApplicant = false;
      }
    },
    onPrint(item) {
      this.isShowUserModal = false;
      this.$nextTick(() => {
        this.printData = item;
        this.isPrintableApplicant = true;
      });
    },
    refreshList() {
      // ApplyDonorListComp의 sendQuery()를 호출하여 조건 유지한 채 새로고침
      if (this.$refs.ApplyDonorList && this.$refs.ApplyDonorList.sendQuery) {
        this.$refs.ApplyDonorList.sendQuery();
      }
    }
  }
};
</script>

<style></style>
